import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StandardAutoCloseGameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/game/screen/StandardAutoCloseGameModeTransitionView";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {TimelineLite, TweenLite} from "gsap";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TombOfAkhenatenTextStyles} from "../config/TombOfAkhenatenTextStyles";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {TombOfAkhenaten} from "../TombOfAkhenaten";
import {SoundManager} from "../sound/SoundManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";

export class TombOfAkhenatenFreeSpinOutroView extends StandardAutoCloseGameModeTransitionView {
    private _compCallback: () => void;
    private _fsContent: PIXI.Container;
    private _deviceOrientation: Orientation;
    private _scroll: PIXI.Sprite;
    private _fsZoomOutSpine: PIXI.spine.Spine;

    private _totalWinText: PIXI.Text;
    private _totalWinNum: PIXI.Text;
    private _multiplierText: PIXI.Text;
    private _multiplierNum: PIXI.Text;
    private _spinPlayedText: PIXI.Text;
    private _spinPlayedNum: PIXI.Text;

    private _fsOutroContainer: PIXI.Container;
    private _gameData: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData;

    constructor(layer: ScalableLayer) {
        super(layer);
    }

    public prepare(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): void {
        this._gameData = data;
        super.prepare(data);
    }

    public startTimerAndEnableButton(callback: () => void) {
        this._compCallback = callback;
        this._button.enabled = false;
        this._button.visible = false;
    }

    getStartAnimation(prepareToEnterModeCallback: () => void, completeCallback: () => void): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        SoundManager.playBonusGameOutroSound();

        tl.add(() => {
            this._totalWinText.visible = !TombOfAkhenatenGameModuleConfig.featurePrice.isWinBelowStake();
            this._totalWinNum.text = (this._gameData.totalWin).toFixed(2);
            this._multiplierNum.text = (this._gameData.payoutMultiplier).toString();
            this._spinPlayedNum.text = (this._gameData.numberOfFreespinsPlayed!).toString();
            this._fsZoomOutSpine.updateTransform();
            this._fsZoomOutSpine.visible = true;
            this.adjustText();
            SlotGame.winFieldController.showWinField(undefined, undefined, true);
        }, 0);

        tl.add(() => {
            new SpineTween(this._fsZoomOutSpine, 0, "zoomOutAnimation", 0);
        }, 1);

        tl.add(() => {
            TweenLite.fromTo(this._scroll, 0.5, {
                alpha: 0
            }, {
                alpha: 1
            });

            TweenLite.fromTo(this._fsOutroContainer, 0.5, {
                alpha: 0
            }, {
                alpha: 1,
                onComplete: () => {
                    this._button.enabled = true;
                    this._button.visible = true;
                }
            });
        }, 3);
        tl.add(() => {
            SoundManager.stopBonusBgSound();

            // #437
            //if (!(SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (this._gameData.totalWin <= (<TombOfAkhenatenParsedGameData>this._gameData).playedBetValue))) {
            if (!TombOfAkhenatenGameModuleConfig.featurePrice.isWinBelowStake()) {
                SoundManager.playBonusGameEndSound();
            }
        })

        tl.play(0);
        return super.getStartAnimation(prepareToEnterModeCallback, completeCallback);
    }

    public getEndAnimation(): TimelineLite {
        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.RESET_MULTIPLIER));
        TombOfAkhenaten.keypad.setZeroBetSpinCounter(-1);
        TombOfAkhenatenGameModuleConfig.featurePrice.reset();
        return super.getEndAnimation();
    }

    protected createBackground(): PIXI.DisplayObject {
        return new PIXI.Container();
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        this._autoCloseTimer.visible = false;

        this._fsContent = new PIXI.Container();
        this._fsContent.name = "_fsContent";

        this._fsZoomOutSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("fsZoomOutSpine"));
        this._fsZoomOutSpine.position.set(0, 0);
        this._fsZoomOutSpine.scale.set(1);
        this._fsZoomOutSpine.visible = false;

        this._scroll = new PIXI.Sprite(GameResources.getTextures("outroScroll")[0]);
        this._scroll.name = "blankScroll";
        this._scroll.anchor.set(0.5);
        this._scroll.alpha = 0;
        this._scroll.position.set(0, TombOfAkhenatenGameConfig.instance.JACKPOT_HEIGHT / 2);

        this._totalWinText = new PIXI.Text(Translation.translate("TOTAL WIN"), TombOfAkhenatenTextStyles.FS_OUTRO_FONT);
        this._totalWinText.name = "totalWinText";
        this._totalWinText.anchor.set(0.5);
        this._totalWinText.position.set(0, -150);
        this._totalWinText.scale.set(2);
        this._totalWinNum = new PIXI.Text("0", TombOfAkhenatenTextStyles.TOA_NUM_FONT);
        this._totalWinNum.anchor.set(0.5);
        this._totalWinNum.scale.set(0.85);
        this._totalWinNum.position.set(0, -85);

        this._multiplierText = new PIXI.Text(Translation.translate("FINAL MULTIPLIER"), TombOfAkhenatenTextStyles.FS_OUTRO_FONT);
        this._multiplierText.name = "multiplierText";
        this._multiplierText.anchor.set(0.5);
        this._multiplierText.scale.set(1.3);
        this._multiplierText.position.set(0, 25);
        this._multiplierNum = new PIXI.Text("0", TombOfAkhenatenTextStyles.TOA_NUM_FONT);
        this._multiplierNum.anchor.set(0.5);
        this._multiplierNum.scale.set(0.5);
        this._multiplierNum.position.set(0, 70);

        this._spinPlayedText = new PIXI.Text(Translation.translate("AKHENATEN SPINS PLAYED"), TombOfAkhenatenTextStyles.FS_OUTRO_FONT);
        this._spinPlayedText.name = "spinPlayedText";
        this._spinPlayedText.anchor.set(0.5);
        this._spinPlayedText.scale.set(1.3);
        this._spinPlayedText.position.set(0, 150);
        this._spinPlayedNum = new PIXI.Text("0", TombOfAkhenatenTextStyles.TOA_NUM_FONT);
        this._spinPlayedNum.anchor.set(0.5);
        this._spinPlayedNum.scale.set(0.5);
        this._spinPlayedNum.position.set(0, 200);

        this._fsOutroContainer = new PIXI.Container();
        this._fsOutroContainer.addChild(this._totalWinText, this._totalWinNum, this._multiplierText, this._multiplierNum, this._spinPlayedText, this._spinPlayedNum);
        this._fsOutroContainer.alpha = 0;

        this.adjustText();

        this._fsContent.addChild(this._fsZoomOutSpine, this._scroll, this._fsOutroContainer);

        return this._fsContent;
    }

    protected onResize(data: IResizeData): void {
        super.onResize(data);
        this._deviceOrientation = data.orientation;
        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        this._fsContent.position.set(this._screenRect.width * 0.5, this._screenRect.height * 0.45);
        this.adjustText();
    }

    protected createButton(): NineSliceButton {
        const text: string = Translation.translate("CONTINUE");
        const textStyle: TextStyleOptions = this.getButtonTextStyle();
        this._button = new NineSliceButton(() => this.onFSContinueClick(), ` ${text} `, textStyle);
        this._button.enabled = false;
        this._button.visible = false;
        return this._button;
    }

    private getButtonTextStyle(): TextStyleOptions {
        const style: TextStyleOptions = this.BUTTON_TEXT_STYLE;
        if (typeof style.fontSize !== 'number') {
            debugger;
            throw new Error("Error: IntoView.getScaledButtonTextStyle(): please use number fontSize!");
        }
        style.fontSize = (<number>style.fontSize) * this._deviceScale;
        return style;
    }

    private onFSContinueClick() {
        this._button.enabled = false;
        this._button.visible = false;
        this._fsZoomOutSpine.visible = false;
        this._fsOutroContainer.alpha = 0;
        this._scroll.alpha = 0;

        SoundManager.playFSContinueBtnSound();

        if (this._compCallback) {
            this.stopTimerAndDisableButton();
            this._compCallback();
        }
    }

    private getMaxTextWidth(): number {
        return Math.max(this._totalWinText.width, this._multiplierText.width, this._spinPlayedText.width);
    }

    private adjustText(): void {
        let reelAreaWidth: number = TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH,
            maxWidth: number = this.getMaxTextWidth();

        if (this._deviceOrientation === Orientation.PORTRAIT) {
            reelAreaWidth = TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.95
        }

        if (maxWidth > reelAreaWidth) {
            this._fsOutroContainer.scale.set(parseFloat((reelAreaWidth / maxWidth).toFixed(2)));
        } else {
            this._fsOutroContainer.scale.set(1);
        }
    }
}
